/**
 * Packaging OS — Button primitive (Phase 1N-B).
 *
 * Two visual weights (primary, secondary) plus a low-emphasis ghost.
 * All visual properties come from CSS classes that consume tokens —
 * no inline color/spacing.
 */

import type { ButtonHTMLAttributes, ReactNode } from "react";

export type ButtonVariant = "primary" | "secondary" | "ghost";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  children: ReactNode;
}

export function Button({
  variant = "primary",
  children,
  className,
  ...rest
}: ButtonProps): JSX.Element {
  const cls = `po-btn po-btn--${variant}${className ? ` ${className}` : ""}`;
  return (
    <button type="button" className={cls} {...rest}>
      {children}
    </button>
  );
}
